import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import Icon from '../../../components/Icon';
import { SET_REPOSITORY_SEARCH } from '../../../constants/ActionTypes';
export const Search = ({ repositories, search, history, dispatch }) => {
    const updateSearch = (event, pathname = location.pathname) => {
        if ((typeof event === 'object' && event.target.value === '') || event === '') {
            history.replace(pathname.substring(0, pathname.lastIndexOf('?search')));
        }
        if (typeof event === 'object' && event.target.value !== '') {
            history.replace(`${pathname}?search=${event.target.value}`);
        }
        dispatch({
            type: SET_REPOSITORY_SEARCH,
            payload: typeof event === 'object' ? event.target.value.substring(0, 20) : event,
        });
    };
    const keyword = 'search=';
    const searchString = search.indexOf(keyword) !== -1 ? search.substring(search.indexOf(keyword) + keyword.length, search.length) : '';
    if (!location.search.includes(searchString)) {
        if (!repositories.search && searchString) {
            updateSearch(searchString);
        }
        if (repositories.search && search === '') {
            history.replace(`${location.pathname}?search=${repositories.search}`);
        }
    }
    return (_jsxs("div", { className: "repositories__search", children: [_jsx("input", { type: "text", className: "form-control", placeholder: "Search", value: repositories.search ? repositories.search : searchString, onChange: updateSearch, autoFocus: true }), repositories.search && (_jsx("button", { className: "repositories__search-clear btn btn-link", onClick: () => updateSearch(''), children: _jsx(Icon, { name: "times" }) }))] }));
};
